{
  "version": 1,
  "asset_id": "6fe561d7-8153-4771-80dc-6725133d388c",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/6fe561d7-8153-4771-80dc-6725133d388c/lecanto-metal-roof-before-768w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/6fe561d7-8153-4771-80dc-6725133d388c/lecanto-metal-roof-before-768w.avif",
  "original_filename": "lecanto-metal-roof-before-768w.avif",
  "size": 62868,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:47Z"
}
